import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const LoginCallback: React.FC = () => {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const hasHandledRedirect = useRef(false);

  useEffect(() => {
    if (hasHandledRedirect.current) return;
    hasHandledRedirect.current = true;
    const handleAuthRedirect = async (): Promise<void> => {
      try {
        const tokens = await oktaAuth.token.parseFromUrl();
        oktaAuth.tokenManager.setTokens(tokens.tokens);
        const originalUri = oktaAuth.getOriginalUri();
        navigate(toRelativeUrl(originalUri || "/", window.location.origin));
        oktaAuth.removeOriginalUri();
      } catch (error) {
        console.error("Error handling redirect:", error);
      }
    };
    handleAuthRedirect();
  }, [oktaAuth, navigate]);

  return <div />;
};
